import { FunctionComponent } from 'react'
import logoConexa from '@/assets/logo-conexa.svg'
import { ClinicLogoProps } from './types'
import { RenderIf } from '@/components/RenderIf'
import { useStyles } from './styles'
import { ConexaLogo } from '@conexasaude/conexa-hero'

const ClinicLogo: FunctionComponent<ClinicLogoProps> = ({ uniqueCode }) => {
  const styles = useStyles()

  return (
    <div>
      <div css={styles.container}>
        <div css={styles.row}>
          <div css={styles.columnLogo}>
            <RenderIf
              condition={
                !!uniqueCode && uniqueCode.toLocaleLowerCase() !== 'conexa'
              }
            >
              <img
                src={`${process.env.VITE_APP_LINK_LOGO_AWS}${uniqueCode}.png`}
                onError={event => {
                  event.currentTarget.onerror = null
                  event.currentTarget.src = logoConexa
                  event.currentTarget.style.height = 'auto'
                }}
                height="40px"
                alt=""
              />
            </RenderIf>
            <RenderIf condition={!uniqueCode}>
              <ConexaLogo base="colorful" inverse />
            </RenderIf>
          </div>
        </div>
      </div>
    </div>
  )
}

export { ClinicLogo }
